import React, { Component } from "react";
import classNames from 'classnames';
import Navlink from "./wrappers/Navlink";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ListItemText from '@material-ui/core/ListItemText';
import { connect } from "react-redux";
import { MAPCLIENT_URL_DOMAIN } from "../utils/constants";
const styles = theme => ({
    root: {
        width: '100%',
    },
    rootForDivider: {
        width: '100%',
        maxWidth: '360px',
        backgroundColor: theme.palette.background.paper,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
});

class Sidenav extends Component {

      constructor(props)
      {
          super(props);
          this.state={
              uMenu: false,
              isLayerDisable: true,
              userRoles:[],
              apiKey: localStorage.apiKey,
              m2: 'none',
              m1: 'none',
          }
    }

    componentWillReceiveProps(props) {
        if (props.notExpiredPackage !== this.props.notExpiredPackage) {
            if (props.notExpiredPackage.packageNames.includes('LayerManagement')) {
                this.setState({ isLayerDisable: false })
            };
        }
        if (props.userRoles.userRoles.includes(1)) {
            this.setState({
                m2: '',
                m1: 'display',
            });
        } else {
            this.setState({
                m2: 'display',
                m1: '',
            })
        }
    }

    renderMenu() {
    const { classes } = this.props;
    return (
      <nav className="col-md-12 d-none d-md-block bg-light sidebar">
        <div className="sidebar-sticky">
          <ul className="nav flex-column">
            <li style={{marginLeft: '8px'}} className="nav-item">
              <Navlink className="nav-link" to="/dashboard">
                <i className="fas fa-chart-line classes.heading" />Dashboard
              </Navlink>
            </li>
            <ExpansionPanel style={{ display: `${this.state.m1}` }}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}><i className="fas fa-list-ul" />Dashboard</Typography>
                </ExpansionPanelSummary>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" />Users</Typography>
                    </ExpansionPanelSummary>
                        <div className={classes.rootForDivider}>
                            <List component="nav">
                                <Navlink className="nav-link" to="/users">
                                    <ListItem button>
                                            Users
                                    </ListItem>
                                </Navlink>
                                <Divider light />
                                <Navlink className="nav-link" to="/users/main">
                                    <ListItem button>
                                        Main Users
                                    </ListItem>
                                </Navlink>
                                <Divider light />
                                <Navlink className="nav-link" to="/users/plain">
                                    <ListItem button>
                                        Plain Users
                                    </ListItem>
                                </Navlink> 
                                <Navlink className="nav-link" to="/users/email">
                                    <ListItem button>
                                           Email Users
                                    </ListItem>
                                </Navlink>
                            </List>
                        </div>
                        {/*
                        <div>
                        <ExpansionPanelSummary expanded={false}>
                            <Typography className={classes.heading}><i className="fas fa-list-ul" />My License</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelSummary  expanded={false}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" /><a href={`http://localhost:50568/app/index.html?apikey=` + this.state.apiKey} 
                          target="_blank">Go to Map</a></Typography>
                        </ExpansionPanelSummary>
                        </div>
                        */}  
                    </ExpansionPanel>

                    <ExpansionPanel style={{ display: `${this.state.m1}` }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}><i className="fas fa-list-ul" />Layer Management</Typography>
                        </ExpansionPanelSummary>
                        <div className={classes.rootForDivider}>
                            <List component="nav">
                                <Navlink className="nav-link" to="/layers/request">
                                    <ListItem button>
                                        Update Layer Request
                                    </ListItem>
                                </Navlink>
                            </List>
                        </div>
                    </ExpansionPanel>

                    <ExpansionPanel disabled={this.state.isLayerDisable} style={{ display: `${this.state.m2}` }}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" />Layer Management</Typography>
                    </ExpansionPanelSummary>
                    <div className={classes.rootForDivider}>
                        <List component="nav">
                            <Navlink className="nav-link" to="/upload">
                                <ListItem button>
                                    Upload File
                            </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/files">
                                <ListItem button>
                                    Files
                                </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/layers">
                                <ListItem button>
                                    Layers
                                </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/layers/published">
                                <ListItem button>
                                    Publish Layers View
                                </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/layers/public">
                                <ListItem button>
                                    Layer Catalogs
                                </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/layers/reqpublic">
                                <ListItem button>
                                    Public Layer Requests
                                </ListItem>
                            </Navlink>
                        </List>
                    </div>
                </ExpansionPanel>
                <li style={{ marginLeft: '8px', display: `${this.state.m2}` }} className="nav-item">
                    <Navlink className="nav-link" to="/projects">
                        <i className="fas fa-chart-line classes.heading" />My Projects
                    </Navlink>
                </li>

                <li style={{ marginLeft: '8px', display: `${this.state.m2}` }} className="nav-item">
                    <Navlink className="nav-link" to="/license">
                        <i className="fas fa-chart-line classes.heading" />My License
                    </Navlink>
                </li>
                <li style={{ marginLeft: '8px', display: `${this.state.m2}` }} className="nav-item">
                        <Navlink className="nav-link" to={`http://` + MAPCLIENT_URL_DOMAIN+`/app/index.html?k=` + this.state.apiKey+ `&ses=`+ localStorage.sessionKey}  target='_blank'>
                        <i className="fas fa-chart-line classes.heading" />Go to Map
                    </Navlink>
                </li>
                </ul>
                </div>
                </nav>
            )
        }
/*
        if (this.state.m1 != '') {
            return (
                <div>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" />Dashboard</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" />Users</Typography>
                    </ExpansionPanelSummary>
                    <div className={classes.rootForDivider}>
                        <List component="nav">
                            <Navlink className="nav-link" to="/users">
                                <ListItem button>
                                    Users
                                    </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/users/main">
                                <ListItem button>
                                    Main Users
                                    </ListItem>
                            </Navlink>
                            <Divider light />
                            <Navlink className="nav-link" to="/users/plain">
                                <ListItem button>
                                    Plain Users
                                    </ListItem>
                            </Navlink>
                        </List>
                    </div>
                    {/*
                        <div>
                        <ExpansionPanelSummary expanded={false}>
                            <Typography className={classes.heading}><i className="fas fa-list-ul" />My License</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelSummary  expanded={false}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" /><a href={`http://localhost:50568/app/index.html?apikey=` + this.state.apiKey} 
                          target="_blank">Go to Map</a></Typography>
                        </ExpansionPanelSummary>
                        </div>
                        *//*}
      /*          </ExpansionPanel>

                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" />Layer Management</Typography>
                    </ExpansionPanelSummary>
                    <div className={classes.rootForDivider}>
                        <List component="nav">
                            <Navlink className="nav-link" to="/layers/request">
                                <ListItem button>
                                    Update Layer Request
                                    </ListItem>
                            </Navlink>
                        </List>
                    </div>
                    </ExpansionPanel>   
                </div>
            )
        }
    }
*/
    render() {
    const { classes } = this.props;
    return (
      <nav className="col-md-2 d-none d-md-block bg-light sidebar">
        <div className="sidebar-sticky">
          <ul className="nav flex-column">
            <li style={{marginLeft: '8px'}} className="nav-item">
              <Navlink className="nav-link" to="/dashboard">
                <i className="fas fa-chart-line classes.heading" />Dashboard
              </Navlink>
            </li>
            {this.renderMenu(classes)}        
          </ul>
        </div>
        <div style={{ display:`${this.props.isDisplayOn}` }} className="loadingSpinner"></div>
      </nav>
    );
  } 
}
Sidenav.propTypes = {
    classes: PropTypes.object.isRequired,
};

let SidenavWithStyles = withStyles(styles)(Sidenav);
  
export default SidenavWithStyles;
  



// WEBPACK FOOTER //
// ./src/components/Sidenav.js